import moment from 'moment';

export default {

   	num_word: (value, words) => {
      value = Math.abs(value) % 100; 
		  var num = value % 10;
		  if(value > 10 && value < 20) return words[2]; 
		  if(num > 1 && num < 5) return words[1];
		  if(num == 1) return words[0]; 
		  return words[2];
    },

    badgeDateParam: (date) => {
        if (moment().format('YYYY-MM-DD') == moment(date).format('YYYY-MM-DD')) {
          return { class: 'badge--red', text: 'Сегодня' };
        }
        if (moment().add(1,'days').format('YYYY-MM-DD') == moment(date).format('YYYY-MM-DD')) {
          return { class: 'badge--blue', text: 'Завтра' };
        }
        if (moment().add(1,'days') < moment(date)) {
          return { class: 'badge--gray', text: moment(date).format('DD.MM.YYYY') };
        }
    },

    statusWorkParam: (status) => {
    	if(status == 0) {
          return { class: 'status--empty', text: '' };
    	}
    	if(status == 1) {
          return { class: 'status--success', text: 'Выполнено' };
    	}
    	if(status == 2) {
          return { class: 'status--error', text: 'Не выполнено' };
    	}
    },

    toBase64: (file) => {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
      });
    }, 


    buildFio (f, i, o, isFull = false) {
      let fio = '';
      // Фамилия с большой буквы
      if(f !== null && f.length !== 0) {
        fio += f.charAt(0).toUpperCase() + f.slice(1).trim();
      }
      // Первая буква имени - большая
      if(i !== null && i.length !== 0) {
        if(isFull) {
          fio += ' ' + i.trim().charAt(0).toUpperCase() + i.slice(1);
        } else {
          fio += ' ' + i.trim().charAt(0).toUpperCase() + '.';
        }
      }
      // Первая буква отчества - большая
      if(o !== null && o.length !== 0) {
        if(isFull) {
          fio += ' ' + o.trim().charAt(0).toUpperCase() + o.slice(1);
        } else {
          fio += ' ' + o.trim().charAt(0).toUpperCase() + '.';
        }
      }
      return fio;
    },

    validateFields: (form) => {
      let isError = false;

      // Проверка на обязательное заполнение
      for (var key in form) {
        // Проверка обязательности ввода
        if(form[key].required.status) {
          // Прроверка заполнения
          if(form[key].value == null || form[key].value.length == 0) {
            form[key].error.status = true;
            form[key].error.message = form[key].required.message;
            isError = true;
          }
        }
      }
      if(isError) return false;

      // Проверка регулярками
      for (key in form) {

        // Поле не обязательное и пустое
        if(form[key].value == null || form[key].value.length == 0) {
          continue;
        }

        // Цикл по регуляркам
        for (var i = 0; i <= form[key].validate.length - 1; i++) {
          // Валидация регуляркой значения
          if(!form[key].validate[i].regexp.test(form[key].value.toString().trim())) {
            form[key].error.status = true;
            form[key].error.message = form[key].validate[i].msg;
            isError = true;
            break;
          }
        }
      }
      if(isError) return false;
      return true;
    },

    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Б', 'Кб', 'Мб', 'Гб', 'Тб', 'Пб', 'EiB', 'ZiB', 'YiB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },

    _snake2Pascal (str) {
        str +='';
        str = str.split('_');
        for(var i=1;i<str.length;i++){ 
            str[i] = str[i].slice(0,1).toUpperCase() + str[i].slice(1,str[i].length);
        }
        return str.join('');
    },

    buildDefaultStructure (meta) {
      var structure = {
        type: "structure",
        description: 'Дом',
        info: "string",
      };
      meta.forEach((item) => {
        const name = this._snake2Pascal(item.name);
        const block = this.buildDefaultBlock(item);
        structure[name] = [];
        structure[name].push(block);
      });
      return structure;
    },

    buildDefaultBlock (block) {
      var element = {
        type: block.name, 
        description: block.description, 
        info: 'string',
      };
      block.child.forEach((child) => {
        const nameChild = this._snake2Pascal(child.name);
        element[nameChild] = [];
        // Для стандартного блока Секции
        if(block.name == 'section' && child.name == 'level_range') {
          // Пушим 1 level_range по умолчанию
          element[nameChild].push({
            type: child.name, 
            description: child.description, 
            info: 'string',
            min: 0,
            max: 0,
          })
        }
      });
      return element;
    },

    resizeArray(arr, newSize, defaultValue) {
      if (newSize > arr.length) {
        while(newSize > arr.length){
          arr.push(defaultValue);
        }
        // arr.length = newSize;
      } else {
        arr.splice(newSize);
      }
    },


    buildModule (module) {
      const templates = [];
      for (let epicKey in module.epics) {
        for (let topicKey in module.epics[epicKey].topics) {
          let dataTopic = this.buildTopic(module.epics[epicKey].topics[topicKey], module.epics[epicKey]);
          templates.push(dataTopic);
        }
      }
      return templates;
    },

    buildTopic(topic, epic) {
      const res = {
        topicNum: topic.num,
        groups: [],
      }
      for (let key_lvl_1 in topic.locations) {
        for (let number_lvl_1 in topic.locations[key_lvl_1]) {
          let loc_lvl_1 = topic.locations[key_lvl_1][number_lvl_1];
          for (let key_lvl_2 in loc_lvl_1.locations) {
            for (let number_lvl_2 in loc_lvl_1.locations[key_lvl_2]) {
              let loc_lvl_2 = loc_lvl_1.locations[key_lvl_2][number_lvl_2];
              for (let groupKey in loc_lvl_2.templateGroups) {
                let group = loc_lvl_2.templateGroups[groupKey];
                let actions = this.buildGroup(group, topic, epic);
                res.groups.push({
                  groupId: group.groupId,
                  actions: actions,
                })
              }
            }
          }
        }
      }
      return res;
    },

    buildGroup (group, topic, epic) {

      let actions = [];
      
      // Осмотр
      if(group.activity.review) {

        const template_id = group.activity.review.templateId !== null ? group.activity.review.templateId : null;
        const function_id = group.activity.review.function !== null ? group.activity.review.function.id : null;
        const employee_id = group.activity.review.employee !== null ? group.activity.review.employee.id : null;
        const ttl = group.activity.review.ttl !== null && Number.isInteger(group.activity.review.ttl) ? group.activity.review.ttl : null;

        group.activity.review.error = [];

        if(ttl == '' || ttl == null || ttl < 1) group.activity.review.error.push('ttl');
        if(employee_id == null) group.activity.review.error.push('employee');

        const review = {
          action_id: group.activity.review.actionId,
          template_id: template_id,
          function_id: function_id,
          employee_id: employee_id,
          ttl: ttl,
        }

        if(group.activity.review.periodical) {
          if(group.activity.review.period[Object.keys(group.activity.review.period)[0]].length == 0) {
            group.activity.review.error.push('period');
          }
          review.period = group.activity.review.period;
        }

        if(group.activity.review.error.length > 0) {
          topic.isError = true;
          if(epic) epic.isError = true;
        }

        actions.push(review);

      }

      // Работа
      if(group.activity.work) {

        const template_id = group.activity.work.templateId !== null ? group.activity.work.templateId : null;
        const function_id = group.activity.work.function !== null ? group.activity.work.function.id : null;
        const employee_id = group.activity.work.employee !== null ? group.activity.work.employee.id : null;
        const ttl         = group.activity.work.ttl !== null && Number.isInteger(group.activity.work.ttl) ? group.activity.work.ttl : null;

        group.activity.work.error = [];

        if(ttl == '' || ttl == null || ttl < 1) group.activity.work.error.push('ttl');
        if(employee_id == null) group.activity.work.error.push('employee');

        let work = {
          action_id: group.activity.work.actionId,
          template_id: template_id,
          function_id: function_id,
          employee_id: employee_id,
          ttl: ttl,
        }

        if(group.activity.work.periodical) {
          if(group.activity.work.period[Object.keys(group.activity.work.period)[0]].length == 0) {
            group.activity.work.error.push('period');
          } 
          work.period = group.activity.work.period;
        }

        if(group.activity.work.error.length > 0) {
          topic.isError = true;
          if(epic) epic.isError = true;
        }

        actions.push(work);

      }

      // Контроль
      if(group.activity.control) {

        const template_id = group.activity.control.templateId !== null ? group.activity.control.templateId : null;
        const function_id = group.activity.control.function !== null ? group.activity.control.function.id : null;
        const employee_id = group.activity.control.employee !== null ? group.activity.control.employee.id : null;
        const ttl         = group.activity.control.ttl !== null && Number.isInteger(group.activity.control.ttl) ? group.activity.control.ttl : null;

        group.activity.control.error = [];

        if(ttl == '' || ttl == null || ttl < 1) group.activity.control.error.push('ttl');
        if(employee_id == null) group.activity.control.error.push('employee');

        let control = {
          action_id: group.activity.control.actionId,
          template_id: template_id,
          function_id: function_id,
          employee_id: employee_id,
          ttl: ttl,
        }
        
        if(group.activity.control.periodical) {
          if(group.activity.control.period[Object.keys(group.activity.control.period)[0]].length == 0) {
            group.activity.control.error.push('period');
          }
          control.period = group.activity.control.period;
        }

        if(group.activity.control.error.length > 0) {
          topic.isError = true;
          if(epic) epic.isError = true;
        }

        actions.push(control);
      }

      return actions;
    },

    transformDynamic (data) {
      const result = [];
      for (let date in data.done) {
        result.push({
          date: date,
          values: [data.done[date], data.issue[date], data.failed[date], data.expired[date]],
        })
      }
      return result;
    },

}